import React from "react";
import { Tooltip } from "@material-ui/core";
// custom tool tip wrapper around component
// component which needs tooltip is rendered as inner component with props.InnerComponent
const CustomToolTip = (props) => {
  return (
    <Tooltip placement="top" arrow={true} title={props.title}>
      <span>{props.InnerComponent}</span>
    </Tooltip>
  );
};

export default CustomToolTip;
